import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminAddNotesComponent } from "../admin-add-notes/admin-add-notes.component";
import { AdminAddTrucksComponent } from "../admin-add-trucks/admin-add-trucks.component";
import { AdminTrucksViewComponent } from "../admin-trucks-view/admin-trucks-view.component";
import { AdminService } from "../admin.service";
import { CommonHelperComponent } from "src/app/common-helper/common-helper.component";

@Component({
  selector: "app-admin-trucks",
  templateUrl: "./admin-trucks.component.html",
  styleUrls: ["./admin-trucks.component.css"],
})
export class AdminTrucksComponent implements OnInit {
  truckType: any = "-1";
  matDialogref!: MatDialogRef<AdminAddNotesComponent>;
  matdialogref!: MatDialogRef<AdminTrucksViewComponent>;
  Matdialogref!: MatDialogRef<AdminAddTrucksComponent>;
  trucksAll: boolean = true;
  trucksAllocated: boolean = false;
  noRecords: boolean = false;
  checkBox: boolean = false;
  truckSelect: boolean = true;
  truckCancel: boolean = false;
  truckDelete: boolean = false;
  DeleteAction: boolean = false;
  addBtn: boolean = true;
  token: any;
  trucksArray: any;
  truckDeleteId: any = [];
  SelectedItems: number = 0;
  document_array: any = [];
  fetch_page: any = 0;
  currentPage: any = 0;
  startPage: any = 1;
  last_page: any = 1;
  toggleSearch: boolean = false;
  searchButton: boolean = true;
  truckNumber: any = -1;
  truck_number: any = [];
  loading: boolean = false;
  clear_btn: boolean = false;
  search_btn: boolean = false;
  isInputValid: boolean = false;
  previousValue: string = "";
  private lengthState: number = 0;

  @ViewChild("newItem") newItem: ElementRef;
  @ViewChild("searchbar") searchbar: ElementRef;
  @ViewChild("newItem", { static: false }) inputElement!: ElementRef;

  constructor(
    private matDialog: MatDialog,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.getTrucks(this.truckNumber);
    // this.pagination(1);
    const savedPage = sessionStorage.getItem("lastTruckFetchPage");
    this.fetch_page = savedPage ? parseInt(savedPage) : 1;

    this.startPage = this.fetch_page;
    this.currentPage = this.fetch_page;
    let triptype = "trucks";
    localStorage.setItem("tripType", triptype);
  }

  getTripsList(selectedTripType: any) {
    this.truckType = selectedTripType;

    // Save tripType to localStorage
    localStorage.setItem("lastTripType", this.truckType);
    if (this.truckType == "-1") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTrucks(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "allocated") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTrucks(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "available") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTrucks(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "under_verification") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTrucks(this.truckNumber);
      this.document_array = [];
    } else if (this.truckType == "maintenance") {
      this.fetch_page = 1;
      this.startPage = 1;
      this.getTrucks(this.truckNumber);
      this.document_array = [];
    }
  }

  addNotes(truckId: any) {
    this.toggleSearch = false;
    this.searchButton = true;
    this.matDialogref = this.matDialog.open(AdminAddNotesComponent, {
      width: "40vw",
      data: {
        _id: truckId,
        module_type: "truck",
      },
      autoFocus: false,
    });
    this.matdialogref.afterClosed().subscribe((x) => {
      this.truckNumber = -1;
      this.getTrucks(this.truckNumber);
      this.addBtn = true;
      this.truckDeleteId = [];
      this.SelectedItems = 0;
    });
  }

  viewTrucks(item: any) {
    this.toggleSearch = false;
    this.searchButton = true;
    this.matdialogref = this.matDialog.open(AdminTrucksViewComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
      data: item,
    });
    this.matdialogref.afterClosed().subscribe((x) => {
      this.truckNumber = -1;
      this.getTrucks(this.truckNumber);
      this.addBtn = true;
      this.truckDeleteId = [];
      this.SelectedItems = 0;
    });
  }

  trucksAdd() {
    this.toggleSearch = false;
    this.searchButton = true;
    this.Matdialogref = this.matDialog.open(AdminAddTrucksComponent, {
      width: "80vw",
      height: "80vh",
      autoFocus: false,
    });
    this.Matdialogref.afterClosed().subscribe((x) => {
      this.getTrucks(this.truckNumber);
    });
  }

  getTrucks(type: any) {
    this.truckNumber = type;
    this.last_page = 1;
    this.loading = true;
    this.services
      .TrucksGet(this.token, this.startPage, this.truckType, this.truckNumber)
      .subscribe(
        (response: any) => {
          this.trucksArray = [];
          this.trucksArray = response.body.data;
          this.document_array.push(response.body.meta);
          this.last_page = response.body.meta.lastPage;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.trucksArray = [];
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });

          if (error.error.message === "Internal server error.") {
            this.trucksArray = [];
            this.truckDelete = false;
            this.addBtn = true;
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
          if (error.error.message === "jwt malformed ") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
        }
      );
  }

  selectCheckbox() {
    this.truckDelete = true;
  }

  selectTruck() {
    this.truckSelect = false;
    this.searchButton = false;
    this.search_btn = false;
    this.truckCancel = false;
    this.DeleteAction = false;
    this.addBtn = false;
    this.toggleSearch = true;
    this.clear_btn = true;
    this.checkBox = true;
    this.truckDelete = true;
  }

  cancelTruck() {
    this.truckNumber = -1;
    this.getTrucks(this.truckNumber);
    this.truckDelete = false;
    this.checkBox = false;
    this.DeleteAction = false;
    this.truckCancel = false;
    this.toggleSearch = false;
    this.searchButton = true;
    this.truckSelect = true;
    this.SelectedItems = 0;
    this.addBtn = true;
    this.clear_btn = false;
    this.search_btn = true;
  }

  public matItem(event: any, item: any, index: number) {
    if (event.checked) {
      this.truckDeleteId.push(item);
      this.SelectedItems += 1;
      this.DeleteAction = true;
      this.truckCancel = true;
    } else {
      this.truckDeleteId.splice(index, 1);
      this.SelectedItems -= 1;
      if (this.SelectedItems == 0) {
        this.DeleteAction = false;
        this.truckCancel = false;
      }
    }
  }

  public deleteTruck() {
    if (this.SelectedItems <= 0) {
      this.snackBar.open("Please select trucks to delete", "Fail", {
        duration: 5000,
      });
      return;
    } else {
      const dialogRef = this.matDialog.open(CommonHelperComponent, {
        data: {
          message: 'Are you sure you want to delete this record?'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result === 'yes') {
          this.services
            .DeleteTruck({ ids: this.truckDeleteId }, this.token)
            .subscribe(
              (response: any) => {
                if (response.status === 200 || response.status === 201) {
                  this.cancelTruck();
                  this.snackBar.open("Truck deleted successfully", "Success", {
                    duration: 5000,
                  });
                  this.getTrucks(this.truckNumber);
                }
              },
              (error) => {
                if (error.error.message === "jwt malformed ") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                if (error.error.message === "jwt expired") {
                  this.router.navigateByUrl("admin/login");
                  window.localStorage.clear();
                }
                this.snackBar.open(error.error.message, "Fail", {
                  duration: 5000,
                });
              }
            );
        }
      });
    }
  }

  onInputChange(input: HTMLInputElement) {
    const value = input.value;
    const previousLength = this.previousValue.length;
    this.previousValue = value;

    if (this.previousValue.length > previousLength && this.clear_btn) {
      this.callApi();
      this.search_btn = true;
      this.clear_btn = false;
    }

    const containsSpecialChars = /[^\w\d]/.test(value);
    if (containsSpecialChars) {
      input.value = value.replace(/[^\w\d]/g, "");
      this.snackBar.open("Special characters are not allowed", "Fail", {
        duration: 5000,
      });
      return;
    }

    this.isInputValid = value.length >= 4;
    switch (previousLength) {
      case 10:
        if (value.length === 9 && this.lengthState !== 9) {
          this.lengthState = 9;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 9:
        if (value.length === 8 && this.lengthState !== 8) {
          this.lengthState = 8;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 8:
        if (value.length === 7 && this.lengthState !== 7) {
          this.lengthState = 7;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 7:
        if (value.length === 6 && this.lengthState !== 6) {
          this.lengthState = 6;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 6:
        if (value.length === 5 && this.lengthState !== 5) {
          this.lengthState = 5;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 5:
        if (value.length === 4 && this.lengthState !== 4) {
          this.lengthState = 4;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      case 4:
        if (value.length === 3 && this.lengthState !== 3) {
          this.lengthState = 3;
          this.callApi();
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;

      default:
        if (value.length >= 4) {
          this.lengthState = 0;
          this.search_btn = true;
          this.clear_btn = false;
        }
        break;
    }

    if (value.length > 10) {
      input.value = value.substring(0, 10);
      this.snackBar.open("Registration Number Limit Exceeded", "Fail", {
        duration: 5000,
      });
    }

    if (value.length === 0) {
      this.resetSearch();
    }
  }

  private callApi() {
    this.truckNumber = -1;
    this.trucksArray = [];
    this.getTrucks(this.truckNumber);
    this.fetch_page = 0;
    this.pagination(1);
  }

  openSearch() {
    this.toggleSearch = true;
    this.searchButton = false;
    this.search_btn = true;
    this.addBtn = false;
    this.truckCancel = false;
    this.truckSelect = false;
    this.DeleteAction = false;
    this.clear_btn = false;
    this.truckDelete = true;
    this.checkBox = true;
    if (this.toggleSearch) {
      setTimeout(() => this.inputElement.nativeElement.focus(), 0);
    }
  }
  resetSearch() {
    if (this.newItem) {
      this.newItem.nativeElement.value = "";
    }
    this.truckNumber = -1;
    this.trucksArray = [];
    this.getTrucks(this.truckNumber);
    this.fetch_page = 0;
    this.pagination(1);
    this.searchButton = true;
    this.toggleSearch = false;
    this.search_btn = false;
    this.clear_btn = false;
    this.addBtn = true;
    this.truckSelect = true;
    this.truckCancel = false;
    this.truckDelete = false;
    this.checkBox = false;
    this.DeleteAction = false;
  }

  search(value: string) {
    const capitalizedValue = value;
    if (value != "") {
      this.searchButton = false;
      this.search_btn = false;
      this.clear_btn = true;
      this.startPage = 1;
      this.getTrucks(capitalizedValue);
      this.fetch_page = 0;
      this.pagination(1);
    } else {
      this.resetSearch();
    }
  }

  // pagination(page_status: any) {
  //   if (page_status == "-1") {
  //     this.fetch_page = parseInt(this.fetch_page) - 1;
  //     this.currentPage = this.fetch_page;
  //     this.startPage = this.currentPage;
  //   }
  //   if (page_status == "1") {
  //     this.currentPage = parseInt(this.fetch_page) + 1;
  //     this.fetch_page = this.currentPage;
  //     this.startPage = this.fetch_page;
  //   }
  //   if (page_status == "first") {
  //     this.fetch_page = this.document_array[0].currentPage;
  //     this.startPage = this.document_array[0].currentPage;
  //   }
  //   if (page_status == "last") {
  //     this.fetch_page = this.document_array[0].lastPage;
  //     this.startPage = this.document_array[0].lastPage;
  //   }
  //   this.getTrucks(this.truckNumber);
  // }

  pagination(page_status: any) {
    let newPage = this.fetch_page;

    if (page_status == "-1") {
      newPage = Math.max(1, this.fetch_page - 1); // Prevent negative pages
    } else if (page_status == "1") {
      newPage = this.fetch_page + 1;
    } else if (page_status == "first") {
      newPage = 1; // Set the first page correctly
    } else if (page_status == "last") {
      newPage = this.last_page || 1; // Ensure last page is fetched correctly
    }

    this.fetch_page = newPage;
    this.currentPage = newPage;
    this.startPage = newPage;

    // Save current page to localStorage
    sessionStorage.setItem("lastTruckFetchPage", newPage.toString());

    this.getTrucks(this.truckNumber);
  }
}
